<template>
    <RichResponseButton
        :title="'Stationsverwaltung öffnen...'"
        @click="() => showModal = true"
    />
    <JobsiteManager v-model="showModal"></JobsiteManager>
</template>

<script setup lang="ts">
import {ref} from "vue";
import RichResponseButton from "@/views/Chat/RichResponses/components/RichResponseButton.vue";
import JobsiteManager from "@/views/Settings/JobsiteManager.vue";

const showModal = ref(true)

</script>
